var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentAdded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1305_2644",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.256592,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1305_2644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.50659 13.9667V11.9535C2.50659 11.459 2.63343 11.0271 2.88709 10.658C3.14076 10.289 3.46948 10.0086 3.87326 9.81668C4.63993 9.47224 5.38143 9.2139 6.09776 9.04168C6.81409 8.86946 7.5337 8.78335 8.25659 8.78335C8.53715 8.78335 8.8177 8.80002 9.09826 8.83335C9.37881 8.86668 9.65381 8.90874 9.92326 8.95952V10.5167C9.64548 10.4611 9.36954 10.4222 9.09543 10.4C8.82143 10.3778 8.54181 10.3667 8.25659 10.3667C7.63437 10.3667 7.03159 10.4278 6.44826 10.55C5.86493 10.6722 5.25265 10.8825 4.61143 11.1807C4.45265 11.2553 4.32326 11.3706 4.22326 11.5263C4.12326 11.682 4.07326 11.8455 4.07326 12.0167V12.4H9.92326V13.9667H2.50659ZM8.25326 7.76668C7.39537 7.76668 6.69537 7.49557 6.15326 6.95335C5.61104 6.41124 5.33993 5.71124 5.33993 4.85335C5.33993 3.99557 5.61104 3.29446 6.15326 2.75002C6.69537 2.20557 7.39537 1.93335 8.25326 1.93335C9.11104 1.93335 9.81493 2.20557 10.3649 2.75002C10.9149 3.29446 11.1899 3.99557 11.1899 4.85335C11.1899 5.71124 10.9149 6.41124 10.3649 6.95335C9.81493 7.49557 9.11104 7.76668 8.25326 7.76668ZM8.25326 6.20002C8.64437 6.20002 8.9677 6.07307 9.22326 5.81918C9.47881 5.56541 9.60659 5.24257 9.60659 4.85068C9.60659 4.45413 9.47993 4.12985 9.22659 3.87785C8.97337 3.62596 8.65115 3.50002 8.25993 3.50002C7.86881 3.50002 7.54548 3.62624 7.28993 3.87868C7.03437 4.13113 6.90659 4.45235 6.90659 4.84235C6.90659 5.2369 7.03326 5.56185 7.28659 5.81718C7.53981 6.07241 7.86204 6.20002 8.25326 6.20002ZM12.2566 15.9833V12.6667H10.9233V8.66668H14.9233L13.5899 11.3333H14.9233L12.2566 15.9833Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentAdded);
export default __webpack_public_path__ + "static/media/recent_added.e9ad0706f9d530773d94e615809b96f3.svg";
export { ForwardRef as ReactComponent };